// extracted by mini-css-extract-plugin
export default {"fontFamily":"Tasks_fontFamily__gZw-a","tableBg":"Tasks_tableBg__UKSA3"};